<script>
import AkLabel from '@components/v2/general/AkLabel';
import Calendar from 'primevue/calendar';

export default {
  components: {AkLabel, Calendar},
  inject: {pSubmitted: {default: null}, pDisabled: {default: null}},
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    format: {
      type: String,
      required: false,
      default: 'HH:mm',
    },
    validator: {
      type: Object,
      required: false,
      default: undefined,
    },
    submitted: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    minDate: {
      type: Date,
      required: false,
      default: undefined,
    },
    maxDate: {
      type: Date,
      required: false,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', this.clampTime(val));
      },
    },
    getPlaceholder() {
      return this.placeholder ? this.placeholder : this.label;
    },
    alreadySubmitted() {
      if (this.submitted !== undefined) return this.submitted;
      if (this.pSubmitted !== undefined) return this.pSubmitted;
      return false;
    },
    isDisabled() {
      if (this.disabled !== undefined) return this.disabled;
      if (this.pDisabled !== undefined) return this.pDisabled;
      return false;
    },
    isInvalid() {
      return this.validator !== undefined && this.validator.$invalid;
    },
    isRequired() {
      return this.validator !== undefined && this.validator.required !== undefined;
    },
    isValidatorRequired() {
      return (
        this.validator !== undefined &&
        this.validator.required !== undefined &&
        this.validator.required.$invalid &&
        this.alreadySubmitted
      );
    },
  },
  methods: {
    clampTime(val) {
      if (!(val instanceof Date)) return val;
      const minutesOf = (d) => d.getHours() * 60 + d.getMinutes();
      let result = val;
      if (this.minDate && minutesOf(val) < minutesOf(this.minDate)) {
        result = new Date(val);
        result.setHours(this.minDate.getHours(), this.minDate.getMinutes());
      } else if (this.maxDate && minutesOf(val) > minutesOf(this.maxDate)) {
        result = new Date(val);
        result.setHours(this.maxDate.getHours(), this.maxDate.getMinutes());
      }
      return result;
    },
  },
};
</script>

<template>
  <div class="w-full form-group" :class="[className]">
    <AkLabel :required="isRequired">
      {{ label }}
    </AkLabel>
    <Calendar
      v-model="currentValue"
      :class="{'p-invalid': isInvalid && alreadySubmitted}"
      :date-format="format"
      :disabled="isDisabled"
      hourFormat="24"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="getPlaceholder"
      :time-only="true"
      class="w-full text-grey-900 text-base font-inter form-control" />
    <small v-if="isValidatorRequired" class="p-error">{{ $t('field_required', [label]) }}</small>
  </div>
</template>
